<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <router-link
                    class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 m-10 text-decoration-none"
                    to="/liste_attribution">
                    Liste des attributions
                    <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                </router-link>
            </div>
            
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="row">
                <div class="col-12">
                    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
                        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
                            <!-- 
                            <h5 class="card-title fw-bold mb-15 mb-lg-20 mb-xl-25">
                                Détail
                            </h5>
                        -->
                            <div class="border p-2 p-lg-4 border-dark border-opacity-10">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="table-responsive">
                                            <table class="table text-nowrap align-middle mb-0">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="text-left fs-18 pt-0" colspan="2">
                                                            Information de l'attrbution
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"
                                                            class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Numéro Attribution
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            {{ retourInfo.attributionId }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"
                                                            class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Date
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            {{ format_Date(retourInfo.dateAttr) }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"
                                                            class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Type
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            Attribution
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"
                                                            class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Agent concerné
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            {{ retourInfo.agent }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="retourInfo.depotId!">
                                                        <th scope="col"
                                                            class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Dépot
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            {{ retourInfo.montantDepot }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="retourInfo.paiementId!">
                                                        <th scope="col"
                                                            class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Paiement
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            {{ retourInfo.montantPayer }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"
                                                            class="text-uppercase text-left fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                                            Intervalles Attribués
                                                        </th>
                                                        <td class="shadow-none lh-1 fw-medium text-primary">
                                                            <span v-for=" (attr, index) in retourInfo.intervalles"
                                                                :key="index"
                                                                class="badge text-bg-success fs-13 m-2 mr-4">{{
                                                                attr.numDebut + " -- " + attr.numFin }}</span>
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>


</template>

<script lang="ts">
import { defineComponent, ref, watch, reactive, toRef, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { useRouter, useRoute } from "vue-router";
import AddCollectionTicket from './AddCollectionTicket.vue';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect'
import axios from 'axios';
import Swal from "sweetalert2";
import { format_Date } from '@/utils/utils';



export default defineComponent({
    name: "DetailAttribution",
    components: {
    },
    setup: () => {
        const route = useRoute();
        const intervalles = ref<Array<any>>([]);
        const id = ref<any>(null)
        const retourInfo = ref<any>({});
        const getRetourById = async (key) => {
            try {
                const response = await axios.get(`recuperation/des/informations/attribution/${key}`);
                const donnee = response.data.data;
                retourInfo.value = donnee;
                for (let i = 0; i < donnee.intervalles.length; i++) {
                    if (i == 0) {
                        donnee.intervalles[i].classContent = "tab-pane fade show active";
                        donnee.intervalles[i].classLink = "nav-link bg-success text-light active";
                    } else {
                        donnee.intervalles[i].classContent = "tab-pane fade";
                        donnee.intervalles[i].classLink = "nav-link";
                    }
                    intervalles.value.push(donnee.intervalles[i]);
                }

            } catch (error) {
                //
            }
        };

        const auClicSurLaTbs = (id) => {
            for (let i = 0; i < intervalles.value.length; i++) {
                if (intervalles.value[i].id == id) {
                    intervalles.value[i].classContent = "tab-pane fade show active";
                    intervalles.value[i].classLink = "nav-link bg-success text-light active";
                } else {
                    intervalles.value[i].classContent = "tab-pane fade";
                    intervalles.value[i].classLink = "nav-link";
                }
            }
        }


        onMounted(async () => {
            id.value = route.params.id;
            await getRetourById(id.value);
        });


        return {
            id,
            intervalles,
            retourInfo,
            format_Date,
            auClicSurLaTbs
        };
    },
});
</script>